import Loading from 'bee-loading'

export default Loading
